export default __webpack_public_path__ + "3559dca2aa9292d098a41d6f99a8bb02.svg";